import ProgressBar from '@ramonak/react-progress-bar'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog'

interface DownloadAlertProps {
  isExporting: boolean
  progress: number
}

export const DownloadAlert = ({
  isExporting,
  progress,
}: DownloadAlertProps) => {
  return (
    <AlertDialog open={isExporting}>
      <AlertDialogContent className="w-96">
        <AlertDialogHeader>
          <AlertDialogTitle>Seu download está em andamento</AlertDialogTitle>
        </AlertDialogHeader>
        <ProgressBar
          transitionDuration="500ms"
          completed={progress}
          maxCompleted={100}
          bgColor="#EA0356"
          width="330px"
        />
      </AlertDialogContent>
    </AlertDialog>
  )
}
